<div class="mat-select-autocomplete-container"
     #container
     [attr.aria-labelledby]="formField?.getLabelId()"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut()">
  <input [id]="inputId"
         matInput
         appVisibilityObserver
         matAutocompleteOrigin
         #input
         #trigger="matAutocompleteTrigger"
         #origin="matAutocompleteOrigin"
         [formControl]="control"
         [matAutocomplete]="autocomplete"
         [matAutocompleteConnectedTo]="autocompleteOrigin || origin"
         (input)="onInput()"
         (visibilityChange)="onVisibilityChange($event)"
         [placeholder]="placeholder"
         [required]="required"
         [matAutocompleteDisabled]="control.disabled" />
  <mat-autocomplete #autocomplete="matAutocomplete"
                    [classList]="['mat-mdc-select-autocomplete-panel']"
                    [displayWith]="displayWith"
                    (optionSelected)="optionSelected($event.option.value)">
    <cdk-virtual-scroll-viewport [itemSize]="appConfig.CDK_VIEWPORT_ITEM_HEIGHT"
                                 (scrolledIndexChange)="onScroll($event)"
                                 [appendOnly]="true"
                                 [maxBufferPx]="2 * appConfig.CDK_VIEWPORT_ITEM_HEIGHT * appConfig.CDK_VIEWPORT_MAXIMUM_ITEM_COUNT"
                                 [minBufferPx]="appConfig.CDK_VIEWPORT_ITEM_HEIGHT * appConfig.CDK_VIEWPORT_MAXIMUM_ITEM_COUNT"
                                 [style.height]="viewportHeight">
      @if (!required && hasData) {
        <mat-option [value]="null">
          {{ valueFormatter(null) }}
        </mat-option>
      }
      <mat-option *cdkVirtualFor="let option of dataSource$ | async" [value]="option">
        {{ valueFormatter(option) }}
      </mat-option>

    </cdk-virtual-scroll-viewport>
  </mat-autocomplete>
</div>
